<template>
    <span :style="{color: category.color}">
        <i :class="`fal fa-${category.icon}`"></i>
    </span>
</template>

<script>
export default {
    name: 'AutomationCategoryIcon',
    inject: ['getAvailableCategories'],
    props: {
        uuid: {
            type: String,
            required: true
        }
    },
    computed: {
        categories() {
            return this.getAvailableCategories({type: null})
        },

        category() {
            return this.categories.find(c => c.uuid === this.uuid) || {}
        }
    }
}
</script>

<style scoped>

</style>
